import TicketDetail from '@/pages/ticketDetail/TicketDetail.page'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Theme, useMediaQuery } from '@mui/material'
import TicketDetailMobile from '@/pages/ticketDetail/TicketDetailMobile.page'

export const Route = createFileRoute('/_auth/ticket/$ticketId')({
  component: () => <TicketDetailLayout />,
  params: {
    parse: (params) => ({
      ticketId: z.number().int().parse(Number(params.ticketId)),
    }),
    stringify: ({ ticketId }) => ({ ticketId: `${ticketId}` }),
  },
  // beforeLoad: async ({ params, context }) => {
  //   const { ticketId } = params;
  //   context.queryClient.prefetchQuery(createTicketByIdQueryOptions(ticketId));
  //   context.queryClient.prefetchQuery(createStatusesByCustomerQueryOptions(ticketId));
  //   context.queryClient.prefetchQuery(createTicketCustomFieldsQueryOptions(ticketId));
  //   context.queryClient.prefetchQuery(createCustomFieldGroupsQueryOptions(ticketId));
  // },
})

const TicketDetailLayout = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  return (
    <>
      {isMobile ? <TicketDetailMobile /> : <TicketDetail />}
    </>
  )
}
